import React from "react";
import {localField} from "../../../../_ae/helpers/UIHelper";
import {fetchOrdersForSelect, useOrdersForSelect} from "../../../../redux/orders";
import {AEAutocompleteField} from "../../../../_metronic/_partials/controls/forms/AEField";
import {useDispatch} from "react-redux";

export const Field = ({...props}) => {
  const dispatch = useDispatch();
  const {data, isLoading, metadata} = useOrdersForSelect()

  const handleSearch = search => {
    dispatch(
      fetchOrdersForSelect({
        ...metadata,
        filters: {
          ...metadata.filters,
          search
        }
      })
    )
  }

  return (
    <AEAutocompleteField
      name="order"
      label={'ORDER'}
      options={data}
      getOptionLabel={option=>option[localField()]}
      onOpen={()=>{
        handleSearch('')
      }}
      onInputChange={(event, search) => {
        handleSearch(search)
      }}
      loading={isLoading}
      {...props}
    />
  )
}